import { useEffect } from 'react'

import { GetStaticPropsContext } from 'next'

import { FlexContainer } from '@/components'
import { HeadTag } from '@/components/headTag'
import { PostsContainer } from '@/containers/posts'
import { GetPostsResponse, getCategories, getPosts } from '@/service/api/blog'
import { Constants } from '@/utils/constants'
import { promiseSettledUtils } from '@/utils/promiseSettled'
import { withFooterHeader } from '@/utils/withFooterHeader'
import { withPageStaticProps } from '@/utils/withPageStaticProps'

export interface BlogProps {
  data: {
    posts: GetPostsResponse
    categories: string[]
  }
}

const Blog: React.FC<BlogProps> = ({ data: { posts, categories } }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <HeadTag
        languageOptions={[]}
        path="/blog"
        description={posts.seo?.metaDescription}
        title={posts.seo?.metaTitle}
        image={posts.seo?.metaImage}
      />
      <FlexContainer
        direction="column"
        justifyContent="center"
        alignItems="center"
        padding="112px 16px 0"
        style={{
          gap: '150px',
          backgroundColor: 'white',
          maxWidth: '100%',
        }}
      >
        <PostsContainer posts={posts} categories={categories} />
      </FlexContainer>
    </>
  )
}

export const getStaticProps = withPageStaticProps(
  async (ctx: GetStaticPropsContext) => {
    const { locale } = ctx
    const { getResults } = promiseSettledUtils()

    const [posts, categories] = await getResults([getPosts(), getCategories()])

    return {
      props: {
        data: {
          posts,
          categories,
        },
      },
      revalidate: Constants.ONE_DAY,
      notFound: locale === 'en',
    }
  },
)

export default withFooterHeader(Blog)
